
export default function ValuesSection() {
  const values = [
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability',
      description: 'Every project incorporates eco-friendly practices, renewable energy, and minimal environmental impact while supporting local ecosystems.'
    },
    {
      icon: 'ri-star-line',
      title: 'Excellence',
      description: 'We maintain the highest standards in design, construction, and operations to deliver exceptional experiences that exceed expectations.'
    },
    {
      icon: 'ri-group-line',
      title: 'Community',
      description: 'Our developments create meaningful economic opportunities for local communities while preserving cultural heritage and natural beauty.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'We continuously push boundaries in glamping design, technology integration, and sustainable hospitality practices.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity',
      description: 'Transparent communication, ethical business practices, and honest partnerships form the foundation of everything we do.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Passion',
      description: 'Our love for the outdoors and commitment to creating magical experiences drives every decision and innovation.'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Values</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The principles that guide our approach to development, operations, and partnerships
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${value.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
